import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ContentTypography from 'components/Common/ContentTypography';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { ReactComponent as Facebook } from 'assets/facebook.svg';
import { ReactComponent as Google } from 'assets/google.svg';
import Ad from 'models/business/Ad';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

function AdCardBar({
  ad,
  onClick,
}) {
  const renderIcon = useMemo(() => {
    if (ad.isGoogle) return <Google className={Styles.icon} />;
    return <Facebook className={Styles.icon} />;
  }, [ad]);

  return (
    <ClickableDiv
      onClick={onClick}
      className={Styles.container}
    >
      <div
        className={Styles.iconBlock}
      >
        {renderIcon}
      </div>
      <div
        className={Styles.nameBlock}
      >
        <ContentTypography>
          {ad.name}
        </ContentTypography>
      </div>
      <div
        className={Styles.arrowIconBlock}
      >
        <ArrowForwardIosIcon style={{ color: '#475E95' }} />
      </div>
    </ClickableDiv>
  );
}

AdCardBar.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onClick: PropTypes.func,
};

AdCardBar.defaultProps = {
  ad: new Ad(),
  onClick: () => {},
};

export default AdCardBar;
